export const SAFE_PDF_RECORDS_NUMBER = 5000;
export const SAFE_PDF_ROWS_PER_DOC_NUMBER = 1000;
export const ABORT_REASONS = {
  MANUALLY: 'Export was aborted manually.',
  SERVER: "Note - The export wasn't completed. Please try again later",
};
